import { put, all, takeLatest, call } from 'redux-saga/effects';
import _isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { getPromoBanner } from 'yoda-interfaces/lib/Pdp/PromoBannerS1Api';
import {
    addApiResponseErrorToStore,
    clearErrorMsgs,
} from 'yoda-site-components/lib/actions/ApiErrorAction';
import CustomErrorLogger from 'yoda-site-components/lib/helpers/CustomErrorLogger/CustomErrorLogger';
import * as PromotionalBannerActionTypes from '../actionTypes/PromotionalBannerActionTypes';

function* IrisS1PromotionalBannerCallSaga(params) {
    try {
        const irisS1PromotionalBannerData = yield call(getPromoBanner, params.urlParams);
        if (irisS1PromotionalBannerData.status < 200 || irisS1PromotionalBannerData.status >= 300) {
            // error happened
            yield put(
                addApiResponseErrorToStore(
                    PromotionalBannerActionTypes.IRIS_S1_PROMOTIONALBANNERDATA_GET_ERROR
                )
            );
        } else {
            let bannerInfo = {};
            const bannerData = get(
                irisS1PromotionalBannerData,
                'content.components[0].content.channels[0]',
                null
            );

            if (!_isEmpty(bannerData)) {
                const {
                    image: {
                        dimensions: { width = '', height = '' } = {},
                        url = '',
                        altText = '',
                    } = {},
                    hotspots = [],
                } = bannerData || {};

                bannerInfo = {
                    isSuccess: true,
                    imageUrl: url,
                    imageAltText: altText,
                    imageWidth: width,
                    imageHeight: height,
                    imagemapArea: hotspots.map((hotspot = {}) => {
                        const { link = {}, linkText, openInNewTab } = hotspot;
                        const hotspotData = { ...hotspot };
                        if (link.url) {
                            hotspotData.leaf = !link.url.includes('X2H2');
                            hotspotData.link = link.url;
                        }
                        hotspotData.alt = linkText;
                        hotspotData.target = openInNewTab ? '_blank' : '_self';
                        return hotspotData;
                    }),
                };
            }

            yield all([
                put(
                    clearErrorMsgs(
                        PromotionalBannerActionTypes.IRIS_S1_PROMOTIONALBANNERDATA_GET_ERROR
                    )
                ),
                put({
                    type: PromotionalBannerActionTypes.IRIS_S1_PROMOTIONALBANNERDATA_GET_SUCCESS,
                    bannerInfo,
                }),
            ]);
        }
        if (_isEmpty(irisS1PromotionalBannerData)) {
            const errorDetails = {
                errorType: 'iris S1 API failure',
                errorDescription: 'iris S1 promotions are not available',
            };
            yield put(CustomErrorLogger.triggerCustomErrorLog(errorDetails));
        }
    } catch (error) {
        const errorDetails = {
            errorType: error.errorCode || 'iris S1 API failure',
            errorDescription: error.errorMessage || 'iris S1 promotions are not available',
        };
        yield put(CustomErrorLogger.triggerCustomErrorLog(errorDetails));
        yield put({ type: 'IRIS_S1_PROMOTIONALBANNERDATA_GET_ERROR', error });
    }
}

const testSaga3 = function* testSaga3() {
    // Your test saga code goes here
};

const watchIrisS1PromotionalBannerSaga = function* watchIrisS1PromotionalBannerSaga() {
    yield takeLatest('IRIS_S1_PROMOTIONALBANNERDATA_GET_REQUEST', IrisS1PromotionalBannerCallSaga);
    //   yield takeLatest('PRODUCTDETAILS_GET_REQUEST', IrisS1PromotionalBannerCallSaga);
    yield takeLatest('TEST_ACTION_CHECK', testSaga3);
};
watchIrisS1PromotionalBannerSaga.sagaName = 'IrisS1PromotionalBannerSaga';
export default watchIrisS1PromotionalBannerSaga;
